import { css } from "styled-system/css";

export const containerStyles = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "calc(100dvh - 4rem)",
  backgroundColor: "bgBase200",
  padding: "lg",
});

export const cardStyles = css({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "md",
  backgroundColor: "bgBase100",
  borderRadius: "large",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "color-mix(in srgb, {colors.textBase}, transparent 90%)",
  boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  width: "100%",
  maxWidth: "24rem",
  padding: "xl",
  textAlign: "center",
  color: "color-mix(in srgb, {colors.textBase}, transparent 35%)",
});

export const titleStyles = css({
  fontFamily: "sans",
  fontWeight: 900,
  letterSpacing: "tight",
  color: "textBase",
  fontSize: "h2",
  margin: 0,
});

export const messageStyles = css({
  fontSize: "sm",
  fontWeight: 500,
  color: "color-mix(in srgb, {colors.textBase}, transparent 40%)",
  margin: 0,
  lineHeight: 1.5,
});

export const actionsStyles = css({
  width: "100%",
  marginTop: "sm",
});
